module.exports = __webpack_public_path__ + "img/prices.65c36eb3.svg";